import { FieldValues, UseFormMethods } from "react-hook-form";

export const initializeDefaultValues = (sections: any[]): Record<string, any> => {
  const initialValues: Record<string, any> = {};
  sections.forEach(section => {
    section.items.forEach((item: any) => {
      initialValues[item.value] = item.defaultValue || "";
      if (item.items) {
        item.items.forEach((subItem: any) => {
          initialValues[subItem.value] = subItem.defaultValue || "";
        });
      }
    });
  });
  return initialValues;
};

export const resetFormValues = <T extends FieldValues>(
  sections: any[],
  setValue: UseFormMethods<any>['setValue'],
  reset: UseFormMethods<any>['reset'],
  defaultValues: T
) => {
  sections.forEach(section => {
    section.items.forEach((item: any) => {
      if (item.type === "radio") {
        setValue(item.value, undefined);
      }
      if (item.items) {
        item.items.forEach((subItem: any) => {
          if (subItem.type === "radio") {
            setValue(subItem.value, undefined);
          }
        });
      }
    });
  });
  reset(defaultValues);
};